var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.mainLayout,_vm._b({tag:"component",on:{"close":_vm.close}},'component',_vm.propsDown,false))}
var staticRenderFns = []

export { render, staticRenderFns }